module.exports = __webpack_public_path__ + "img/heros-trial.76a26237.png";